import { useMutation, useQuery } from '@apollo/client';
import { Grid, Stack } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useMemo } from 'react';

import { useSourcingCase } from '../Module.hooks';
import { TsrctIssueStatus } from '@/generated/gql/graphql';
import { IssueAlert } from '@/legacy/components/IssueAlert/IssueAlert';

import { SOURCING_CASE_RESUBMIT_MUTATION } from './SourcingCaseIssueWidget.mutation.gql';
import { SOURCING_CASE_ISSUES_QUERY } from './SourcingCaseIssueWidget.query.gql';

export const SourcingCaseIssueWidget = () => {
  const { id } = useSourcingCase();
  const { onError } = useCustomSnackbar();
  const variables = { id };

  const { data } = useQuery(SOURCING_CASE_ISSUES_QUERY, {
    variables,
    skip: !id,
  });
  const [resubmit, { loading }] = useMutation(SOURCING_CASE_RESUBMIT_MUTATION, {
    refetchQueries: [{ query: SOURCING_CASE_ISSUES_QUERY, variables }],
    onError,
  });

  const { hasPermission } = usePermissions();

  const onActionClick = hasPermission(Permission.SourcingCaseResubmit)
    ? async () => {
        resubmit({ variables: { id } });
      }
    : undefined;

  const issuesAll = data?.tesseract.sourcingCase.issues;
  const issuesOpen = useMemo(() => {
    return issuesAll?.filter((issue) => issue.status === TsrctIssueStatus.OPEN) || [];
  }, [issuesAll]);
  const openIssueCount = issuesOpen.length;

  return openIssueCount > 0 ? (
    <Grid container size={12}>
      <Stack spacing={4} sx={{ flexGrow: 1 }}>
        {issuesOpen.map((issue) => {
          return <IssueAlert key={issue.id} variant={issue.variant} loading={loading} onActionClick={onActionClick} />;
        })}
      </Stack>
    </Grid>
  ) : null;
};
